import NewsDestaques from "./NewsDestaques";
import News from "./UniqueNews";
import styles from "../../../styles/module/news-unique.module.css";

export default function NewsContainer({ idNews }) {
  return (
    <div className={styles.news_container}>
      <News idNoticia={idNews} />
      <NewsDestaques excludeId={idNews} />
    </div>
  );
}